module.exports = __webpack_public_path__ + "img/file.8619dc68.svg";